import { render, staticRenderFns } from "./extrafields.vue?vue&type=template&id=76acc077"
import script from "./extrafields.vue?vue&type=script&lang=js"
export * from "./extrafields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports